import { useProductPageStore } from '../../contexts/ProductPageStore'

import React from 'react'

import RecommendationSection from 'Clutch/Organisms/RecommendationSection/RecommendationSection'

import Gutters from 'Clutch/Atoms/Gutters'

const BottomRecommendations = ({ keywords }) => {
  const scrollToTopAndStartNavigation = useProductPageStore((x) => x.scrollToTopAndStartNavigation)

  return (
    <Gutters>
      <RecommendationSection
        extendGuttersForCarousel
        section={'PDP_Bottom'}
        numberOfSkeletons={5}
        numberOfSkeletonSections={3}
        displayType={'Carousel'}
        spacingSize={'XXLG'}
        keywords={keywords}
        nextLink
        prefetch={false}
        onClick={scrollToTopAndStartNavigation}
      />
    </Gutters>
  )
}

export default BottomRecommendations
